import { createModule } from '@/store/type'

export default createModule({
  namespaced: true,
  state: {
  },
  mutations: {
  },
  actions: {
  },
  getters: {
  }
})
